/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCreateAppRequestFromJSON(json) {
    return StreemApiCreateAppRequestFromJSONTyped(json, false);
}
export function StreemApiCreateAppRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'platform': !exists(json, 'platform') ? undefined : json['platform'],
        'platformAppId': !exists(json, 'platform_app_id') ? undefined : json['platform_app_id'],
        'allowMultiCompanyLogin': !exists(json, 'allow_multi_company_login') ? undefined : json['allow_multi_company_login'],
    };
}
export function StreemApiCreateAppRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_sid': value.companySid,
        'platform': value.platform,
        'platform_app_id': value.platformAppId,
        'allow_multi_company_login': value.allowMultiCompanyLogin,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiCreateAppRequestPlatform;
(function (StreemApiCreateAppRequestPlatform) {
    StreemApiCreateAppRequestPlatform["ANDROID"] = "APP_PLATFORM_ANDROID";
    StreemApiCreateAppRequestPlatform["INVALID"] = "APP_PLATFORM_INVALID";
    StreemApiCreateAppRequestPlatform["IOS"] = "APP_PLATFORM_IOS";
    StreemApiCreateAppRequestPlatform["WEB"] = "APP_PLATFORM_WEB";
})(StreemApiCreateAppRequestPlatform || (StreemApiCreateAppRequestPlatform = {}));
//# sourceMappingURL=StreemApiCreateAppRequest.js.map